module.exports = __webpack_public_path__ + "img/no-data.6e78a0c.png";